import React from 'react';
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Palette } from "lucide-react";
import { useTheme } from 'next-themes';
import { getThemeAwareColor } from '@/utils/colorUtils';

// Light mode colors
const PASTEL_COLORS = [
  '#F2FCE2', // Soft Green
  '#D3E4FD', // Soft Blue
  '#FEC6A1', // Soft Orange
  '#E5DEFF', // Soft Purple
  '#FFDEE2'  // Soft Pink
];

interface ColorPickerProps {
  onColorSelect: (color: string) => void;
  selectedColor: string;
}

const ColorPicker: React.FC<ColorPickerProps> = ({ onColorSelect, selectedColor }) => {
  const { theme } = useTheme();
  
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon">
          <Palette className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-1" style={{ width: 'auto' }}>
        <div className="flex gap-1 p-1">
          {PASTEL_COLORS.map((color) => {
            const displayColor = getThemeAwareColor(color, theme === 'dark');
            return (
              <button
                key={color}
                className={`w-12 h-12 rounded-full border-2 transition-all hover:scale-110 ${
                  selectedColor === color ? 'border-primary' : 'border-transparent'
                }`}
                style={{ backgroundColor: displayColor }}
                onClick={() => onColorSelect(color)}
              />
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default ColorPicker;